/**
 * Background Scroll
 */
export function background_scroll() {
  const sections = document.querySelectorAll('.js-background-scroll');
  if (!sections.length) return;

  sections.forEach((section) => {
    const content = section.querySelector('.background-scroll__panel__inner');

    if (!content) return;

    let resizeTimer = null;
    let lastHeight = 0;

    const setSectionHeight = () => {
      const contentHeight = content.offsetHeight;

      const nextHeight = Math.max(
        Math.ceil(contentHeight),
        window.innerHeight
      );

      if (lastHeight === nextHeight) return;

      lastHeight = nextHeight;

      section.style.setProperty(
        '--background-scroll-height',
        `${nextHeight}px`
      );
    };

    const refresh = () => {
      setSectionHeight();
    };

    const onResize = () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        refresh();
      }, 120);
    };

    refresh();

    window.addEventListener('resize', onResize);
    window.addEventListener('load', refresh);
  });
}